// Экспорт всех SWR хуков и провайдера
export { SWRProvider } from './SWRProvider';
export { fetcher, mutationFetcher, FetchError } from './fetcher';
export { useSiteSettings } from './hooks/useSiteSettings';
export { useNews, useNewsItem } from './hooks/useNews';
export { useVacancies } from './hooks/useVacancies';
export { usePublicProjects, usePublicUserProjects, useMyProjects, useProject } from './hooks/useProjects';
export { useStaff } from './hooks/useStaff';

// Optimistic updates
export {
  createOptimisticOptions,
  optimisticOptions,
  optimisticNoRevalidate,
  optimisticAdd,
  optimisticPrepend,
  optimisticRemove,
  optimisticUpdate,
  optimisticIncrement,
  optimisticToggle,
  optimisticAddToPaginated,
  optimisticUpdateInPaginated,
  optimisticRemoveFromPaginated,
} from './optimistic';

export {
  useNewsLike,
  useProjectLike,
  useNewsComments,
  useProjectComments,
  useMessageReactions,
  useOptimisticMutate,
} from './hooks/useOptimisticMutations';
